import { db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export const dailyHelpService = {
  async evaluateNeeds(responses) {
    try {
      const response = await fetch('https://api-5zm2gcbnlq-ew.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'daily_help_quiz',
          responses,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur serveur');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('💥 Erreur évaluation:', error);
      throw error;
    }
  },

  async askDailyHelp(userQuestion, context = null, conversationHistory = []) {
    try {
      const response = await fetch('https://api-5zm2gcbnlq-ew.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'daily_help_chat',
          question: userQuestion,
          context,
          history: conversationHistory,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur serveur');
      }

      const data = await response.json();
      return data.content;
    } catch (error) {
      console.error('💥 Erreur chat:', error);
      throw error;
    }
  },
  /* ------------------------------------------------------------------ */
  /* 📚 ARTICLES PUBLIÉS (ADMIN → USAGER)                                */
  /* ------------------------------------------------------------------ */

  async getPublishedArticles() {
    try {
      const q = query(collection(db, 'articles'), where('published', '==', true));

      const snapshot = await getDocs(q);

      return snapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          title: data.title,
          description: data.description,
          category: data.category || 'sante-adulte',
          difficulty: data.difficulty || 'Moyen',
          thumbnail: data.thumbnail || '',
          budget: data.budget || 'Non précisé',
          tags: data.tags || [],
          images: data.images || [],
          createdAt: data.createdAt?.toDate?.() || null,
        };
      });
    } catch (error) {
      console.error('❌ Erreur chargement articles publiés:', error);
      return [];
    }
  },

  /* ------------------------------------------------------------------ */
  /* 🔍 RECHERCHE (Firebase + fallback statique)                        */
  /* ------------------------------------------------------------------ */

  async searchResources(query) {
    try {
      const publishedArticles = await this.getPublishedArticles();

      const lowerQuery = query.toLowerCase();

      const categoryTags = {
        amenagement: ['cuisine', 'salle de bain', 'chambre', 'escaliers', 'amenagement'],
        'aides-techniques': ['déambulateur', 'canne', 'fauteuil', 'aides-techniques'],
        gestes: ['se lever', 'toilette', 'gestes'],
        services: ['aide ménagère', 'portage repas', 'services'],
      };

      const matchedArticles = publishedArticles.filter((article) => {
        const matchText =
          article.title.toLowerCase().includes(lowerQuery) ||
          article.description.toLowerCase().includes(lowerQuery);

        const acceptedTags = categoryTags[lowerQuery] || [];
        const matchCategory = article.tags.some((tag) => acceptedTags.includes(tag.toLowerCase()));

        const matchTag = article.tags.some((tag) => tag.toLowerCase().includes(lowerQuery));

        return matchText || matchCategory || matchTag;
      });

      if (matchedArticles.length > 0) {
        return matchedArticles.map((article) => ({
          ...article,
          category: article.tags[0] || 'general',
        }));
      }

      // Fallback données statiques
      const staticResources = [
        {
          id: 'static-1',
          category: 'amenagement',
          title: 'Sécuriser la salle de bain',
          description: 'Guide complet pour adapter votre salle de bain',
          budget: '150-500€',
          difficulty: 'Facile',
          tags: ['salle de bain', 'sécurité', 'chute'],
        },
        {
          id: 'static-2',
          category: 'aides-techniques',
          title: 'Déambulateurs et cannes',
          description: 'Comment choisir son aide à la marche',
          budget: '30-200€',
          difficulty: 'Facile',
          tags: ['mobilité', 'marche'],
        },
        {
          id: 'static-3',
          category: 'amenagement',
          title: 'Adapter la cuisine',
          description: 'Aménagements pour cuisiner en sécurité',
          budget: '100-800€',
          difficulty: 'Moyen',
          tags: ['cuisine', 'autonomie'],
        },
        {
          id: 'static-4',
          category: 'gestes',
          title: 'Se lever du lit en sécurité',
          description: 'Techniques pour éviter les chutes',
          budget: 'Gratuit',
          difficulty: 'Facile',
          tags: ['lever', 'lit', 'chute'],
        },
        {
          id: 'static-5',
          category: 'services',
          title: 'Aide ménagère à domicile',
          description: "Comment bénéficier d'une aide ménagère",
          budget: 'Variable',
          difficulty: 'Moyen',
          tags: ['aide', 'ménage', 'APA'],
        },
        {
          id: 'static-6',
          category: 'aides-techniques',
          title: 'Téléalarme et détecteur de chute',
          description: 'Systèmes de sécurité',
          budget: '20-50€/mois',
          difficulty: 'Facile',
          tags: ['téléalarme', 'sécurité'],
        },
      ];

      return staticResources.filter(
        (resource) =>
          resource.title.toLowerCase().includes(lowerQuery) ||
          resource.description.toLowerCase().includes(lowerQuery) ||
          resource.tags.some((tag) => tag.includes(lowerQuery))
      );
    } catch (error) {
      console.error('❌ Erreur recherche:', error);
      return [];
    }
  },
};
